// Added By Farhan Khan Khan on 24-Dec-2025
/* eslint-disable no-lone-blocks */
import React, { useState, useEffect } from "react";
import { Alert, Col, Container, Row, Modal } from "react-bootstrap";
import Button from "react-bootstrap/Button";
import Form from "react-bootstrap/Form";
import { Link, useNavigate } from "react-router-dom";
import "react-bootstrap-typeahead/css/Typeahead.css";
import solisPowerApi from "../../api/solisPowerApi";
import moment from "moment";
import { useLocation } from "react-router-dom";
import PubSub from "pubsub-js";
import Select from "react-select";
import Accordion from "react-bootstrap/Accordion";
import Card from "react-bootstrap/Card";
import CityState from "../../constants/CityState.json";
import { LIST_TAB_TITLE } from "../../constants/CONSTANT";
import * as constants from "../../constants/CONSTANT";
import jwt_decode from "jwt-decode";
import Helmet from "react-helmet";
import Main from "../layout/Main";
import { handleUppercaseChange } from "../common/UpperCaseMethod";

const BrandEdit = (props) => {
  const [validated, setValidated] = useState(false);
  const location = useLocation();
  const navigate = useNavigate();
  const [brand, setBrand] = useState(location.state ? location.state : {});

  useEffect(() => {
    // console.log("brand", brand);
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setBrand({ ...brand, [name]: value });
  };

  // Added validation by Farhan Khan starts
  const checkRequiredFields = () => {
    if (
      brand.name &&
      brand.name.trim() !== "" &&
      brand.status &&
      brand.status.trim() !== ""
    ) {
      return false;
    }
    return true;
  };

  // Added validation by Farhan Khan ends

  const handleSubmit = async (e) => {
    e.preventDefault();
    // Added validation by Farhan Khan starts
    if (checkRequiredFields()) {
      setValidated(true);
      return;
    }
    // Added validation by Farhan Khan ends
    //========= Logic to perform Create or Edit ======
    let result = {};
    if (brand.id) {
      result = await solisPowerApi.saveBrand(brand);
      if (result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/brands/${brand.id}`, { state: brand });
      }
    } else {
      result = await solisPowerApi.createBrand(brand);
      if (result != null && result.success) {
        PubSub.publish("RECORD_SAVED_TOAST", {
          title: "Record Saved",
          message: "Record saved successfully",
        });
        navigate(`/brands/${result.id}`, { state: result });
      }
    }
  };

  const handleCancel = () => {
    if (brand.id) {
      navigate("/brands/" + brand.id, { state: brand });
    } else {
      navigate(`/brands`);
    }
  };

  return (
    <Main>
      <>
        <Helmet>
          <title>{LIST_TAB_TITLE.BrandEdit}</title>
        </Helmet>
      </>
      <Container className="view-form">
        <Row>
          <Col></Col>
          <Col lg={8} className="pb-1 pt-2">
            <Link className="nav-link" to="/brands">
              Home <i className="fa-solid fa-chevron-right"></i>{" "}
              <div style={{ color: "#23468c", display: "inline" }}>
                Brands
              </div>
            </Link>
          </Col>
          <Col></Col>
        </Row>
        <Row>
          <Col></Col>
          <Col lg={8}>
            <Form
              className="mt-3"
              onSubmit={handleSubmit}
              noValidate
              validated={validated}
            >
              <Row className="view-form-header">
                <Col lg={8}>
                  {brand.id ? <h5>Edit Brand</h5> : <h5>Create Brand</h5>}
                </Col>
                <Col lg={4} className="d-flex gap-3 justify-content-end">
                  <Button
                    size="sm"
                    className="btn-save"
                    onClick={handleSubmit}
                  >
                    Save
                  </Button>
                  <Button
                    size="sm"
                    className="btn-cancel"
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                </Col>
              </Row>

              <Row className="ibs-edit-form pb-3 ">
                <Row lg={12}>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicName"
                      >
                        Brand Name
                      </Form.Label>
                      <Form.Control
                        required
                        type="text"
                        name="name"
                        placeholder="Enter Brand Name"
                        value={brand.name}
                        onChange={(e) => handleUppercaseChange(e, handleChange)}
                      />
                      <Form.Control.Feedback type="invalid">
                        Please provide Brand Name.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                  <Col lg={6}>
                    <Form.Group className="mx-3">
                      <Form.Label
                        className="form-view-label"
                        htmlFor="formBasicStatus"
                      >
                        Status
                      </Form.Label>
                      <Form.Select
                        aria-label="Select status"
                        name="status"
                        value={brand.status}
                        onChange={handleChange}
                        required
                      >
                        <option value="">--Select--</option>
                        <option value="Active">Active</option>
                        <option value="Inactive">Inactive</option>
                      </Form.Select>
                      <Form.Control.Feedback type="invalid">
                        Please provide status.
                      </Form.Control.Feedback>
                    </Form.Group>
                  </Col>
                </Row>
              </Row>
            </Form>
          </Col>
          <Col></Col>
        </Row>
      </Container>
    </Main>
  );
};

export default BrandEdit;

